import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询用户授权信息
  getAuthInfo(_postData) {
    return http.get(URL.API_OTHER_GET_AUTH_INFO, _postData)
  },
  // 保存授权信息
  setAuthInfo(_postData) {
    return http.post(URL.API_OTHER_SET_AUTH_INFO, _postData)
  },
  mockDingLogin(_postData) {
    return http.post(URL.API_OTHER_MOCK_USERINFO, _postData)
  }
}
